module.exports = __webpack_public_path__ + "img/2.fc21d93a.png";